<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.mdAndDown" persistent content-class="service-logs-dialog" max-width="90%">
    <template v-slot:activator="{ on }">
      <SecondaryBtn icon="event_note" small v-on="on">
        {{$t('Button.ExecutionLogs')}}
      </SecondaryBtn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Execution Logs</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card dark v-if="dialog">
          <v-layout row>
            <v-flex md6 style="padding: 32px 32px 0 32px;">
              <v-text-field readonly label="Service" :value="service.DisplayName" />
            </v-flex>
          </v-layout>
          <v-layout row style="padding: 0 32px 0 32px;">
            <v-flex md12 lg12>
              <v-text-field label="Search Logs" placeholder="Enter search terms" v-model="searchTerm"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row style="padding-left: 32px;">
            <v-flex md6 lg6>
              <v-autocomplete clearable v-model="selectedTenant" :items="tenants" item-text="RoleName" return-object :placeholder="'Select Tenant'"></v-autocomplete>
            </v-flex>
          </v-layout>
          <!-- <CustomDateRangePickerManualTimeSeries
          :minDateBound="getMinStartDate"
          :maxDateBound="getMaxEndDate"
          :resetDateRangeOption="JSON.stringify(dateRangeShortcuts)"
          />-->
          <v-layout>
            <v-flex xs12 sm8 md3 lg3 style="padding-left: 32px;">
              <v-menu v-model="startDateMenu" :close-on-content-click="false" full-width max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedStartDate" label="Select Log Start Date" readonly :hint="'Enter a Valid Date'" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" @change="startDateMenu = false" :min="getMinStartDate" :max="computedEndDate"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm8 md3 lg3 style="margin-left: 16px;">
              <v-menu v-model="endDateMenu" :close-on-content-click="false" full-width max-width="290">
                <template v-slot:activator="{ on }">
                  <v-text-field :value="computedEndDate" label="Select Log End Date" readonly :hint="'Enter a Valid Date'" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" @change="endDateMenu = false" :min="computedStartDate" :max="getMaxEndDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm8 md3 lg3 style="padding-left: 10px;">
              <PresetButtons :direction="'top'" :min-date-bound="minDateBound" :max-date-bound="maxDateBound" @input="onDatePresetSelected" :date-range-shortcuts="dateRangeShortcuts"></PresetButtons>
            </v-flex>
          </v-layout>
          <v-layout style="margin-left: 32px;">
            <v-flex style="flex-grow: 0;">
              <v-checkbox v-model="showLogsIfHasError" label="Errors only"></v-checkbox>
            </v-flex>
            <v-flex style="flex-grow: 0;" class="ml-4">
              <v-checkbox v-model="showLogsIfNotTestRun" label="No test runs"></v-checkbox>
            </v-flex>
            <v-flex style="flex-grow: 0;" class="ml-4">
              <v-checkbox v-model="showLogsIfNotSniff" label="No file format checks"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout pl-4>
            <v-btn color="info" depressed @click="fetchLogs()">{{$t('Button.Search')}}</v-btn>
            <v-btn color="error" depressed @click="clearFilters()">
              <v-icon>clear</v-icon>{{$t('Button.ClearFilters')}}
            </v-btn>
          </v-layout>
        </v-card>
        <v-card>
          <v-layout class="py-5" v-if="isLoading">
            <PageLoader resourceName="Logs" />
          </v-layout>
          <ServiceUserLogs v-if="dialog" ref="serviceLogsComponent" :loading.sync="isLoading" :startDate="computedStartDate" :endDate="computedEndDate" :searchTerm="searchTerm" :tenant="selectedTenant" :showLogsIfHasError="showLogsIfHasError" :showLogsIfNotTestRun="showLogsIfNotTestRun" :showLogsIfNotSniff="showLogsIfNotSniff" :serviceName="service.CapabilityServiceName" />
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <v-spacer />
            <v-btn color="secondary" outline @click="close()">{{$t('Button.Close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>
<script>
  import PresetButtons from '@/components/PresetButtons'
  import ServiceUserLogs from '../../Logs/ServiceUserLogs.vue'
  import CustomDateRangePickerManualTimeSeries from '@/components/CustomDateRangePickerManualTimeSeries'
  import moment from 'moment'

  export default {
    components: {
      PresetButtons,
      ServiceUserLogs,
      CustomDateRangePickerManualTimeSeries,
    },
    props: {
      service: Object,
    },
    data: () => ({
      dialog: false,
      isLoading: false,
      isValidated: false,
      isBlocked: false,
      isSaving: false,
      triggerFetchLogs: false,
      triggerResetLogs: false,
      tenantId: -1,
      processInstanceId: -1,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      minDateBound: '',
      maxDateBound: '',
      searchTerm: '',
      selectedTenant: {},
      showLogsIfHasError: false,
      showLogsIfNotTestRun: false,
      showLogsIfNotSniff: false,
    }),
    computed: {
      computedStartDate() {
        return this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : moment().subtract(14, 'days').format(
          'YYYY-MM-DD')
      },
      computedEndDate() {
        return this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      },
      getMinStartDate() {
        return moment(this.computedEndDate).subtract(6, 'months').format('YYYY-MM-DD')
      },
      getMaxEndDate() {
        return moment(this.computedStartDate).add(6, 'months').format('YYYY-MM-DD')
      },
      tenants() {
        return this.$store.getters['admin/roleList']
      },
      dateRangeShortcuts() {
        return {
          'Most recent two weeks': {
            startDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          'Most recent month': {
            startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          'Most recent 3 months': {
            startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          'Most recent 6 months': {
            startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
        }
      },
    },
    methods: {
      fetchLogs() {
        if (this.$refs.serviceLogsComponent)
          this.$refs.serviceLogsComponent.fetchLogs()
      },
      resetLogs() {
        if (this.$refs.serviceLogsComponent)
          this.$refs.serviceLogsComponent.resetLogs()
      },
      close() {
        this.clearFilters()
        this.resetLogs()
        this.dialog = false
      },
      onDatePresetSelected(presetName) {
        var dateRangeObj = this.dateRangeShortcuts[presetName]
        this.startDate = dateRangeObj.startDate
        this.endDate = dateRangeObj.endDate
      },
      clearFilters() {
        this.startDate = null
        this.endDate = null
        this.startDateMenu = false
        this.endDateMenu = false
        this.minDateBound = ''
        this.maxDateBound = ''
        this.selectedTenant = {}
        this.showLogsIfHasError = false
        this.showLogsIfNotTestRun = false
        this.searchTerm = ''
      },
      mounted() {
        this.startDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
        this.endDate = moment().format('YYYY-MM-DD')
        let roleList = this.$store.getters['admin/roleList']
        if (roleList == null || roleList.length == 0) {
          this.$store.dispatch('admin/getRoleList')
        }
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .service-logs-dialog {
    display: flex;
    flex-direction: column;
  }
</style>